import { Form, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
//icons
import { BsSearch } from 'react-icons/bs';
//constants
import { choicesUserType, getOrderStatus } from '../../../constants';
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';
import Select from 'components/backoffice/selects/SelectCustom';
import SearchCompanyInput from 'components/backoffice/customInput/SearchCompanyInput';
import { SelectInputCustom } from 'components/input';

const FiltersTableOrders = ({ formFilter, handleClear, setFormFilter, t, page, setPage }) => {
  const choices = [{
    id: '',
    value: t('faqs.none')
  }, ...getOrderStatus(t)];

  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  return (
    <SearchTable multipleInput={true} handleClear={handleClear} className="w-100">
      <Form className="form-filter-list">
        <Row>
          <Col xl={3} lg={6} md={12} xs={12} className="mb-3 mb-xl-0">
            <Select
              placeholder={t('userTypes')}
              value={formFilter.usertype}
              onCheckedItem={(e) => handleSearch(e, 'usertype')}
              choices={choicesUserType(t, true)}
            />
          </Col>
          <Col xl={3} lg={6} md={12} xs={12} className="mb-3 mb-xl-0">
            <SelectInputCustom
              value={formFilter.status}
              onCheckedItem={(e) => handleSearch(e, 'order_status')}
              choices={choices}
            />
          </Col>
          <Col xl={3} lg={6} md={12} xs={12} className="mb-3 mb-lg-0">
            <SearchCompanyInput
              onSelected={(item) => handleSearch(item, 'benefited_company')}
              defaultCompany={formFilter.benefited_company}
              hasLabel={false}
              placeholder={t('searchByBookstore')}
              className="orders m-0"
            />
          </Col>
          <Col xl={3} lg={6} md={12} xs={12}>
            <CustomInput
              handleKeyDown={true}
              type="text"
              placeholder={t('searchByOrder')}
              value={formFilter.code}
              onChange={(e) => handleSearch(e, 'code')}
              icon={<BsSearch color="#161A25" className="icon-search" />}
            />
          </Col>
        </Row>
      </Form>
    </SearchTable>
  )
}

FiltersTableOrders.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func
};

export default FiltersTableOrders;